import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { SUB_FACTOR_OPTIONS } from '@/pages/instruments/new-instrument/constants/sub-factors'

export interface SubFactorFormFieldProps {}

export const SubFactorFormField: React.FC<SubFactorFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ sub_factor: string | null }>()

  return (
    <FormField
      name="sub_factor"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Sub Factor</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              showNone="None"
              placeholder={'Select a sub factor...'}
              value={value?.toString()}
              setValue={(value) =>
                setValue('sub_factor', value ? value : null, { shouldValidate: true })
              }
              options={SUB_FACTOR_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
